import JumpButtonGroup from './JumpButtonGroup';
import ZoomControls from './ZoomControls';
import PageNavigation from './PageNavigation';
import PdfSearchPanel from '../../PdfSearchPanel';

/**
 * ツールバーコンポーネント
 * ジャンプボタン、ズームコントロール、ページナビゲーションを統合
 */
const Toolbar = ({
  isMobile,

  // JumpButtonGroup props
  activeJumpButton,
  canJumpDisease,
  canJumpContents,
  canJumpLegend,
  canJumpAppendix,
  onJumpCurrentDisease,
  onJumpContents,
  onJumpLegend,
  onJumpAppendix,

  // ZoomControls props
  zoomLevel,
  onZoomIn,
  onZoomOut,

  // PageNavigation props
  currentPage,
  totalPages,
  isRendering,
  onPrevPage,
  onNextPage,
  pageInputValue,
  onChangePageInput,
  onPageInputKeyDown,
  onPageInputBlur,

  // キーワード検索 props
  searchText,
  onSearchTextChange,
  searchResults,
  currentSearchIndex,
  isSearching,
  isSearchOpen,
  onToggleSearchOpen,
  onSearch,
  onNextSearchResult,
  onPrevSearchResult,
  onClearSearch,
  pdfDocument,
  searchError,

}) => {

  // キーワード検索コントロールに渡すprops
  const controlProps = {
    searchText,
    onSearchTextChange,
    searchResults,
    currentSearchIndex,
    isSearching,
    onSearch,
    onNextSearchResult,
    onPrevSearchResult,
    onClearSearch,
    pdfDocument,
    isMobile,
    searchError,
  };

  return (
    <>
      <div className="pdf-toolbar">
        {/* 右側コントロール群（ズーム・ページャー・検索・閉じる） */}
        <div className="pdf-toolbar-controls">
          {/* ズームコントロール */}
          <ZoomControls
            zoomLevel={zoomLevel}
            onZoomIn={onZoomIn}
            onZoomOut={onZoomOut}
          />

          {/* ページナビゲーション */}
          <PageNavigation
            currentPage={currentPage}
            totalPages={totalPages}
            isRendering={isRendering}
            onPrevPage={onPrevPage}
            onNextPage={onNextPage}
            pageInputValue={pageInputValue}
            onChangePageInput={onChangePageInput}
            onPageInputKeyDown={onPageInputKeyDown}
            onPageInputBlur={onPageInputBlur}
          />

          {/* PCレイアウト時: キーワード検索パネルを表示 */}
          {!isMobile && (
            <div className="pdf-search-toolbar-panel">
              <PdfSearchPanel {...controlProps} />
            </div>
          )}
          {/* モバイルレイアウト時: キーワード検索ボタン表示 */}
          {isMobile && (
            <PdfSearchPanel.Trigger
              isSearchOpen={isSearchOpen}
              onToggleSearchOpen={onToggleSearchOpen}
            />
          )}

        </div>
      </div>

      {/* モバイルレイアウト時: キーワード検索パネルをアコーディオン表示（ツールバー直下） */}
      {isMobile && (
        <div className={`pdf-search-accordion ${isSearchOpen ? 'open' : ''}`}>
          <div className="pdf-search-accordion-inner">
            <PdfSearchPanel {...controlProps} />
          </div>
        </div>
      )}

      {/* 該当疾病/目次/凡例/別表ボタンバー */}
      <div className="pdf-jump-bar">
        <JumpButtonGroup
          activeJumpButton={activeJumpButton}
          canJumpDisease={canJumpDisease}
          canJumpContents={canJumpContents}
          canJumpLegend={canJumpLegend}
          canJumpAppendix={canJumpAppendix}
          onJumpCurrentDisease={onJumpCurrentDisease}
          onJumpContents={onJumpContents}
          onJumpLegend={onJumpLegend}
          onJumpAppendix={onJumpAppendix}
        />
      </div>
    </>
  );
};

export default Toolbar;
